import styled from "styled-components/macro";
import { BREAK_ } from "constants";

export const Aside = styled.aside`
  background: ${({ clr, filter }) => (filter ? `${clr?.primary}e6` : "transparent")};

  ${BREAK_.md_dn} {
    position: fixed;
    top: ${({ filter }) => (filter ? "69px" : "70px")};
    height: 100%;
    width: 100%;
       background-color: ${({ filter }) => (filter ? `${clr?.primary}e6`  : "#FFF")};
    z-index: 55;
  }

  ${BREAK_.md_up} {
    z-index: ${({ list }) => (list ? 12 : 15)};
    height: ${({ filter, matches }) =>
      filter ? (matches ? "auto" : "auto") : "100%"};
    width: ${({ w }) => (typeof w === "number" ? `${w}px` : w)};
    
    min-width: ${({ mw }) => mw}px;
    position: fixed;
    ${({ filter, isIsometry }) =>
      filter ? { bottom: isIsometry ? "102px" : "102px" } : { top: "72px" }};

    /* ✅ OPEN FROM LEFT for list */
    left: ${({ left, nav, list ,filter }) =>
      left
        ? list
          ? `${nav ? 300 : 8}px` // list drawer appears beside nav
          : filter ?`${nav ? 300 : 48}px` // other left drawers
        : 0 :"unset"};

    /* ✅ Unit Drawer stays on the right */
    right: ${({ right }) => (right ? 0 : "unset")};

    /* ✅ Solid white for drawers, transparent for filter overlay */
    background-color: ${({ filter }) => (filter ? `${clr?.primary}e6`  : "#FFF")};
  }

  display: flex;
  flex-direction: column;
  align-items: center;
`;
